import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';

@Injectable({ providedIn: 'root' })
export class IntentMatchStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'intent';
  readonly defaultWeight = 50;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    if (!ctx.intent) return null;
    const target = ctx.intent.target.toLowerCase().trim();
    if (!target) return null;

    const haystack = `${this.normalizedTitle(item)} ${this.normalizedDescription(item)} ${this.normalizedKeywords(item).join(' ')}`;
    if (haystack.includes(target)) {
      return this.match(this.id, this.defaultWeight, `intent:${ctx.intent.action}`);
    }
    return null;
  }
}
